import React, { useState, useCallback  } from "react";
import config from "../../config";
import { Link } from "gatsby";
import { useSpring, animated } from "react-spring";
import MediaQuery from 'react-responsive';

function Menu({isMenuOpen}) {

  const [toogleMenu, set] = useState(false);
  const handleClickClose = useCallback(() => {
    // handle the click event
    set(false);
    isMenuOpen(false);
  }, []);
  const handleClickOpen = useCallback(() => {
    // handle the click event
    set(true);
    isMenuOpen(true);
  }, []);

  const props = useSpring({
    from: { opacity: 0, number: 0 },
    to: { opacity: 1, number: 100 },
    config: { mass: 100, tension: 500, friction: 420 },
    delay: 1000
  });

  
  const propsMovile = useSpring({
    from: { opacity: 0, number: 0 },
    to: { opacity: toogleMenu ? 1 : 0, number: toogleMenu ? 100 : 0 },
    config:  {tension: 280, friction: 120},
    delay: 100
  });

  return (
  <>
    <MediaQuery maxDeviceWidth={1224}>
       {
        toogleMenu ?  
        <animated.span class="icon fa-times menu-icon" onClick={handleClickClose} style={{ width: props.number + "%", height: props.number + "%", opacity: props.opacity , transform:`rotate(${props.number}deg)` , zIndex: 1001, display: 'block'}}></animated.span> : 
        <animated.span class="icon fa-bars menu-icon" onClick={handleClickOpen}  style={{ width: props.number + "%", height: props.number + "%", opacity: props.opacity , transform:`rotate(${props.number}deg)`,  zIndex: 1001, display: 'block'}}></animated.span>
       } 
    </MediaQuery>

    <animated.div
          className={toogleMenu ?  'open-menu':''}
          style={ toogleMenu ? 
            { width: propsMovile.number + "%", opacity: propsMovile.opacity, zIndex: '1000'} : 
            { width: props.number + "%", opacity: props.opacity ,  zIndex: '100'} }
      >

          <ul className={toogleMenu ?  'menu open-menu':'menu'} style={{ zIndex: '1000'}}>
            {config.menuSections.map(menu => {
              const { name, url, categories} = menu;
              return toogleMenu && name === "PROYECTOS" ? 
              <> 
                <Link to={url}>{name}</Link>
                <div style={{ paddingLeft: "3.5em"}}> 
                {categories.map( c =>  {
                  return  <div style={{ padding: "1em"}}>
                      <li> <Link to={ url+'/#'+ c.name }>{ c.name }</Link></li>
                    </div> 
                }) }   
                </div> 
              </> 
              : <Link to={url}>{name}</Link>;
            })}
              <MediaQuery maxDeviceWidth={1224}>
            
                <ul className="icons">
                  {config.socialLinks.map(social => {
                    const { icon, name, url } = social;
                    return (
                      <li key={url}>
                        <a href={url} className={`icon alt ${icon}`}>
                          <span className="label">{name}</span>
                        </a>
                      </li>
                    );
                  })}
              </ul>
          </MediaQuery>
        </ul>
      </animated.div>
    </>
  );
}
export default React.memo(Menu)